var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container container_40 portfolio-transactions" },
    [
      _c("div", { staticClass: "text_large text_bold" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.i18n.th_transaction_history()) + "\n    "
        )
      ]),
      _vm._v(" "),
      _vm.list.length
        ? _c(
            "md-list",
            {
              staticClass: "md-layout portfolio-transactions__list transparent"
            },
            [
              _vm._l(_vm.list, function(tx, i) {
                return i < _vm.transactionsToShow
                  ? _c(
                      "md-list-item",
                      {
                        key: i,
                        class: [
                          "list-item",
                          tx.state === "rejected" || tx.state === "failed"
                            ? "list-item_opacity"
                            : ""
                        ],
                        attrs: { "md-expand": "" }
                      },
                      [
                        _c("div", { staticClass: "list-item_left" }, [
                          _c("div", { staticClass: "text_large text_bold" }, [
                            _vm._v(" " + _vm._s(tx.name) + " ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text_medium text_margin" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    tx.direction === "in" ? "from" : "to"
                                  ) +
                                  " " +
                                  _vm._s(tx.counterparty) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text_small text_description" },
                            [_vm._v(" " + _vm._s(tx.date) + " ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "list-item_right" }, [
                          _c(
                            "div",
                            {
                              staticClass: "text_large text_bold",
                              class: [
                                "list-item__amount",
                                "list-item__amount--" + tx.direction,
                                tx.state === "pending"
                                  ? "list-item__amount--pending"
                                  : "",
                                tx.state === "rejected" || tx.state === "failed"
                                  ? "list-item__amount--failed"
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(tx.direction === "in" ? "+" : "-") +
                                  _vm._s(_vm.i18n.c(tx.amount)) +
                                  " " +
                                  _vm._s(tx.asset) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text_medium text_margin" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(tx.direction === "in" ? "+" : "-") +
                                  _vm._s(_vm.i18n.c(tx.quoteAmount)) +
                                  " " +
                                  _vm._s(tx.quoteAsset) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "text_small",
                              class:
                                "list-item__state list-item__state--" + tx.state
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    tx.state === "confirm"
                                      ? "success"
                                      : tx.state
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "list-item__details",
                            attrs: { slot: "md-expand" },
                            slot: "md-expand"
                          },
                          [
                            _c("tx-details", {
                              staticClass: "info-dialog__history",
                              attrs: { tx: _vm.list[i] }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-wrap margin-top" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "btn md-primary",
                      attrs: { to: "/history/index/" + _vm.tokenCode }
                    },
                    [_vm._v(_vm._s(_vm.i18n.lbl_view_more()))]
                  )
                ],
                1
              )
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "container__no-data text-center" },
            [
              _c("md-icon", { staticClass: "md-size-4x" }, [
                _vm._v("trending_up")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text_xl_large" }, [
                _vm._v(_vm._s(_vm.i18n.th_no_transaction_history()))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text_margin text_medium" }, [
                _vm._v(_vm._s(_vm.i18n.th_here_will_be_the_list()))
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75131a92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75131a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/portfolio/Portfolio.Transactions.vue
// module id = DXQG
// module chunks = 1